import { render, staticRenderFns } from "./ExternalOrganizationForm.vue?vue&type=template&id=b418796c&"
import script from "./ExternalOrganizationForm.vue?vue&type=script&lang=js&"
export * from "./ExternalOrganizationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports